import { render } from "./examExistPrompty.vue?vue&type=template&id=3bac59e8&scoped=true"
import script from "./examExistPrompty.vue?vue&type=script&lang=js"
export * from "./examExistPrompty.vue?vue&type=script&lang=js"

import "./examExistPrompty.vue?vue&type=style&index=0&id=3bac59e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bac59e8"]])

export default __exports__